import PropTypes from 'prop-types';
import './animated-mark.css';

const AnimatedNaraMark = ({ startup = false }) => (
  <span className={`nf-signature${startup ? ' is-startup' : ' is-looping'}`}>
    <span className="nf-signature__glow" aria-hidden="true" />
    <img
      data-testid="nara-loading-mark"
      className="nf-signature__mark"
      src="/nara-v42-loading.svg"
      alt=""
      aria-hidden="true"
    />
  </span>
);

AnimatedNaraMark.propTypes = { startup: PropTypes.bool };

export default AnimatedNaraMark;
